import { typeActionCreator, valueActionCreator } from "../action_creators";
export var SEARCH_RESULT_START = 'SEARCH_RESULT_START';
export var SEARCH_RESULT_UPDATE = 'SEARCH_RESULT_UPDATE';
export var SEARCH_RESULT_SCHOOL_START = 'SEARCH_RESULT_SCHOOL_START';
export var SEARCH_RESULT_SCHOOL_UPDATE = 'SEARCH_RESULT_SCHOOL_UPDATE';
export var SEARCH_RESULT_SET_EXPANDED_SCHOOL = 'SEARCH_RESULT_SET_EXPANDED_SCHOOL';
export var SEARCH_RESULT_SAVE_PROFILE = 'SEARCH_RESULT_SAVE_PROFILE';
export var SEARCH_RESULT_CLEAR = 'SEARCH_RESULT_CLEAR';
export var SEARCH_RESULT_SET_PARAMETERS = 'SEARCH_RESULT_SET_PARAMETERS';
export var SEARCH_SET_SHOULD_VALIDATE_ELIGIBILITY = 'SEARCH_SET_SHOULD_VALIDATE_ELIGIBILITY';
export var SEARCH_SET_TAB = 'SEARCH_SET_TAB';
export var SEARCH_SET_META = 'SEARCH_SET_META';
export var SEARCH_NEXT_PAGE = 'SEARCH_NEXT_PAGE';
export var SEARCH_SET_PAGE_LOADING = 'SEARCH_SET_PAGE_LOADING';
// export type searchStartType = () => ActionType;
// export type searchResultsType = (Array<ProgramListInfo>, append) => ActionType;
// export type searchSchoolStartType = (number | string) => ActionType;
// export type searchSchoolResultsType = (number | string, Array<ProgramListInfo>) => ActionType;
// export type searchSetExpandedSchoolType = (number | string | null) => ActionType;
// export type searchSetMetaType = (any) => ActionType;

export var searchStart = typeActionCreator(SEARCH_RESULT_START);
export var searchResults = function searchResults(value) {
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: SEARCH_RESULT_UPDATE,
    value: value,
    append: append
  };
};
export var searchSchoolStart = function searchSchoolStart(programId) {
  return {
    type: SEARCH_RESULT_SCHOOL_START,
    programId: programId
  };
};
export var searchSchoolResults = function searchSchoolResults(programId, results) {
  return {
    type: SEARCH_RESULT_SCHOOL_UPDATE,
    programId: programId,
    value: results
  };
};
export var searchSetExpandedSchool = valueActionCreator(SEARCH_RESULT_SET_EXPANDED_SCHOOL);
export var searchResultSaveProfile = valueActionCreator(SEARCH_RESULT_SAVE_PROFILE);
export var searchResultClear = typeActionCreator(SEARCH_RESULT_CLEAR);
export var searchResultSetParameters = valueActionCreator(SEARCH_RESULT_SET_PARAMETERS);
export var searchSetShouldValidateEligibility = valueActionCreator(SEARCH_SET_SHOULD_VALIDATE_ELIGIBILITY);
export var searchSetTab = valueActionCreator(SEARCH_SET_TAB);
export var searchSetMeta = valueActionCreator(SEARCH_SET_META);
export var searchNextPage = typeActionCreator(SEARCH_NEXT_PAGE);
export var searchSetPageLoading = valueActionCreator(SEARCH_SET_PAGE_LOADING);